<form [formGroup]="formAviso" (ngSubmit)="submit()">
    <div class="row">
        <div class="col">
            <label class="w-100">{{ 'AVISOS.TITLE' | translate }}</label>
            <input class="w-100"type="text" name="titulo" formControlName="titulo">
        </div>
    </div>
    <div class="row mt-3">
        <div class="col">
            <label class="w-100">{{ 'AVISOS.DESC' | translate }}</label>
            <textarea rows="4" cols="90" name="cuerpo" formControlName="cuerpo"></textarea>
        </div>
    </div>
    
    <input type="file" class="mt-3 upload" name="file" accept="application/pdf" (change)="onFileChange($event)">
    
    <div class="w-100">
        <mat-checkbox formControlName="visible" class="mt-2">{{ 'AVISOS.ACTIVE' | translate }}</mat-checkbox>
    </div>

    <div *ngIf = "adviseError || typeError || uploadSucesfully" class="w-100 d-flex justify-content-center">
        <div *ngIf = "adviseError" class="danger alert-danger adviseError">
            <p class="mt-2">{{ 'AVISOS.ERR_REQUIRED' | translate }}</p>
        </div>

        <div *ngIf = "typeError" class="danger alert-danger typeError">
            <p class="mt-2">{{ 'AVISOS.ERR_PDF' | translate }}</p>
        </div>

        <div *ngIf = "uploadSucesfully" class="alert alert-success uploadSucesfully">
            <p>{{ 'AVISOS.OK' | translate }}</p>
        </div>
    </div>

    <div class="w-100 mt-3 d-flex justify-content-center">
        <button type="submit" class="btn btn-primary m-left">{{ 'AVISOS.SAVE' | translate }}</button>
    </div>
    
</form>
